// /src/store/booleanMap/reducer.ts

import {
  UPDATE_BOOLEAN_MAP,
  BooleanMapState,
  initialState,
  BooleanMapActionTypes
} from './types';

const booleanMapReducer = (state = initialState, action: BooleanMapActionTypes): BooleanMapState => {
  switch (action.type) {
    case UPDATE_BOOLEAN_MAP:
      return {
        ...state,
        booleanMap: {
          ...state.booleanMap,
          [action.payload.key]: action.payload.value,
        },
      };

    default:
      return state;
  }
};

export default booleanMapReducer;
